import { SITE_PLAN } from "@/lib/sitePlan";

// The padlock that stands where a Premium price would be (index-lock mock,
// option C, 2026-10-12). Drawn, not an emoji: an emoji renders differently on
// every phone and cannot take the panel's colour. Laid out inline: it is drawn
// on the website and in the app, and the two load different stylesheets.
export default function LockMark({ label = SITE_PLAN.short }: { label?: string | null }) {
  return (
    <span className="rbtx-lock" style={{ display: "inline-flex", alignItems: "center", gap: "0.4em", fontWeight: 900 }}>
      <svg width="13" height="15" viewBox="0 0 16 18" aria-hidden="true" style={{ flex: "none" }}>
        <rect x="1.5" y="8" width="13" height="9" rx="2" fill="currentColor" />
        <path d="M4.5 8V5.5a3.5 3.5 0 0 1 7 0V8" fill="none" stroke="currentColor" strokeWidth="2" />
      </svg>
      {label ? <span>{label}</span> : <span className="sr-only">Premium</span>}
    </span>
  );
}
